export default __webpack_public_path__ + "static/media/ag-grey.b8e6f6f2.svg";